import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Congratulation } from '../../SpinTheWheel/Congratulation';
import LanguagePicker from '../../Helpers/Selectbox/LanguagePicker';
import SpinWheel from '../../SpinTheWheel/SpinWheel';
import PrimaryPopup from '../../popups/PrimaryPopup';
import { Mail } from '../../Helpers/icons/Icons';

type PropsType = {
  className?: string;
};

export default function TopBar({ className }: PropsType) {
  const { t } = useTranslation();
  const [showSpinWheel, setShowSpinWheel] = useState(false);
  const [searchParams] = useSearchParams();
  const spinAndWinParam = searchParams.has('spin_and_win');
  const couponFromParam = searchParams.get('coupon');
  const showSpinWheelByParams = searchParams.has('widget') && !!couponFromParam;

  useEffect(() => {
    if (spinAndWinParam || showSpinWheelByParams) {
      setShowSpinWheel(true);
    }
  }, [spinAndWinParam, showSpinWheelByParams]);

  return (
    <>
      <div className={`w-full bg-ink-900 text-ink-200 ${className || ''}`}>
        <div className='container-x'>
          <div className='flex h-[38px] items-center justify-between gap-4 text-[12px]'>
            <div className='flex items-center gap-5'>
              <a
                href='mailto:info@egiftcards.am'
                className='flex items-center gap-2 transition-colors hover:text-apricot-300'
              >
                <Mail size={13} />
                info@egiftcards.am
              </a>
            </div>

            <div className='flex items-center gap-5'>
              <Link
                to='/become-seller'
                className='hidden transition-colors hover:text-apricot-300 md:block'
              >
                {t('become_a_partner')}
              </Link>
              <span className='hidden h-3 w-px bg-ink-700 md:block' />
              <div className='language-select flex items-center'>
                <LanguagePicker />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showSpinWheel && (
        <PrimaryPopup
          className='max-w-[700px] h-full sm:h-fit sm:rounded-card rounded-none sm:px-[18px] pt-[18px] sm:my-[20px]'
          onClose={() => setShowSpinWheel(false)}
          title=''
        >
          <div className='sm:mt-[-32px] pb-[40px]'>
            {showSpinWheelByParams ? <Congratulation coupon={couponFromParam} /> : <SpinWheel />}
          </div>
        </PrimaryPopup>
      )}
    </>
  );
}
